import { render, staticRenderFns } from "./BaseFooterQuery.vue?vue&type=template&id=67387086&scoped=true&"
import script from "./BaseFooterQuery.vue?vue&type=script&lang=js&"
export * from "./BaseFooterQuery.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterQuery.vue?vue&type=style&index=0&id=67387086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67387086",
  null
  
)

export default component.exports